require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-srsholmes-colors-re.json") })
        }
      }, "path---package-unpublished-srsholmes-colors-re");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-srsholmes-colors-re!./.cache/json/package-unpublished-srsholmes-colors-re.json
// module id = 965
// module chunks = 231608221292675